import { assign } from 'lodash';
import { DATA_STATES } from '@/store/consts';
import MedalliaService from '@/services/medallia/MedalliaService';
import { MUTATION_TYPES } from './mutations';
import { actions as baseActions, ACTION_TYPES as BASE_ACTION_TYPES } from '../base-collection/actions';

const ACTION_TYPES = assign({}, BASE_ACTION_TYPES, {
  FETCH_MEDALLIA_INITIALIZATION_INFO: 'fetchMedalliaInitializationInfo',
  FETCH_MEDALLIA_ACCOUNT_INFO: 'fetchMedalliaAccountInfo',
  SET_CONFIGURATION_STEP: 'setConfigurationStep',
  FETCH_SKILLS: 'fetchSkills',
  FETCH_SURVEYS: 'fetchSurveys',
  SELECT_SURVEYS_SKILLS: 'selectSurveySkills',
  DELETE_SURVEYS_SKILLS: 'deleteSurveySkills',
  DELETE_ALL_SURVEYS_SKILLS: 'deleteAllSurveySkills',
  SELECT_CONFIG_SURVEY_INFO: 'configSurveyInfo',
  TEST_API_CONFIG: 'testAPIConfig',
  SET_SKILL_SURVEY_MAPPINGS: 'setSkillSurveyMappings',
  SAVE_CONFIG_TO_DB: 'saveConfigToDB',
  PATCH_CONFIG_TO_DB: 'patchConfigToDB',
  SET_SURVEY_SKILLS_TO_DB: 'setSurveySkillsToDB',
  DEL_SURVEY_SKILL_FROM_DB: 'delSurveySkillFromDB',
  RESET_CONFIG_SURVEY_INFO: 'resetConfigSurveyInfo',
  UPDATE_SKILL_INTERACTIVENESS: 'updateSkillInteractiveness',
  FETCH_SKILL_INTERACTIVENESS: 'fetchSkillInteractiveness',
});

const actions = assign({}, baseActions, {
  async [ACTION_TYPES.FETCH_MEDALLIA_INITIALIZATION_INFO]({ commit }, medalliaConfig) {
    let medalliaInitializationInfoResponse = null;
    try {
      medalliaInitializationInfoResponse = await MedalliaService.fetchMedalliaInitializationInfo(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return medalliaInitializationInfoResponse;
  },

  async [ACTION_TYPES.FETCH_MEDALLIA_ACCOUNT_INFO]({ commit }, medalliaConfig) {
    let medalliaAccountInfoResponse = null;
    try {
      medalliaAccountInfoResponse = await MedalliaService.fetchMedalliaAccountInfo(medalliaConfig);
    } catch (error) {
      medalliaAccountInfoResponse = Promise.reject(error);
      console.log('error', error, commit);
    }
    return medalliaAccountInfoResponse;
  },

  [ACTION_TYPES.SET_CONFIGURATION_STEP]({ commit }, step) {
    commit(MUTATION_TYPES.SET_CONFIGURATION_STEP, step);
  },

  async [ACTION_TYPES.TEST_API_CONFIG]({ commit }, medalliaConfig) {
    let apiTestResult = null;
    try {
      apiTestResult = await MedalliaService.testMedalliaAPIConfig(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return apiTestResult;
  },

  async [ACTION_TYPES.SAVE_CONFIG_TO_DB]({ commit }, medalliaConfig) {
    let saveConfigResult = null;
    try {
      saveConfigResult = await MedalliaService.saveConfigToDB(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return saveConfigResult;
  },

  async [ACTION_TYPES.PATCH_CONFIG_TO_DB]({ commit }, medalliaConfig) {
    let saveConfigResult = null;
    try {
      saveConfigResult = await MedalliaService.saveConfigToDB(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return saveConfigResult;
  },

  async [ACTION_TYPES.SET_SURVEY_SKILLS_TO_DB]({ commit }, medalliaConfig) {
    let surveySkillsToDBResponse = null;
    try {
      surveySkillsToDBResponse = await MedalliaService.setSurveySkillsToDB(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return surveySkillsToDBResponse;
  },

  async [ACTION_TYPES.DEL_SURVEY_SKILL_FROM_DB]({ commit }, medalliaConfig) {
    let surveySkillFromDBResponse = null;
    try {
      surveySkillFromDBResponse = await MedalliaService.delSurveySkillFromDB(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return surveySkillFromDBResponse;
  },

  async [ACTION_TYPES.UPDATE_SKILL_INTERACTIVENESS]({ commit }, medalliaConfig) {
    let interactivenessDetails = null;
    try {
      interactivenessDetails = await MedalliaService.setSurveyInteractivenessToDB(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return interactivenessDetails;
  },

  async [ACTION_TYPES.FETCH_SKILL_INTERACTIVENESS]({ commit }, medalliaConfig) {
    let interactivenessDetails = null;
    try {
      interactivenessDetails = await MedalliaService.fetchSurveyInteractivenessFromDB(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return interactivenessDetails;
  },

  async [ACTION_TYPES.SET_SKILL_SURVEY_MAPPINGS]({ commit }, medalliaConfig) {
    let surveyMappingsResponse = null;
    try {
      surveyMappingsResponse = await MedalliaService.setSkillSurveyMappingsConfig(medalliaConfig);
    } catch (error) {
      console.log('error', error, commit);
    }
    return surveyMappingsResponse;
  },

  async [ACTION_TYPES.FETCH_SKILLS]({ commit }, medalliaConfig) {
    commit(MUTATION_TYPES.SET_SKILLS_LOADING, DATA_STATES.LOADING);
    try {
      const skills = await MedalliaService.getSkills(medalliaConfig);
      commit(MUTATION_TYPES.SET_SKILLS, skills);
      commit(MUTATION_TYPES.SET_SKILLS_LOADING, DATA_STATES.SUCCESS);
    } catch (er) {
      commit(MUTATION_TYPES.SET_SKILLS_LOADING, DATA_STATES.ERROR);
    }
  },

  async [ACTION_TYPES.FETCH_SURVEYS]({ commit }, medalliaConfig) {
    commit(MUTATION_TYPES.SET_SURVEYS_LOADING, DATA_STATES.LOADING);
    try {
      const surveys = await MedalliaService.getSurveys(medalliaConfig);
      commit(MUTATION_TYPES.SET_SURVEYS, surveys);
      commit(MUTATION_TYPES.SET_SURVEYS_LOADING, DATA_STATES.SUCCESS);
    } catch (er) {
      commit(MUTATION_TYPES.SET_SURVEYS_LOADING, DATA_STATES.ERROR);
    }
  },
  [ACTION_TYPES.SELECT_SURVEYS_SKILLS]({ commit }, selection) {
    commit(MUTATION_TYPES.SET_SURVEYS_SKILLS, selection);
  },
  [ACTION_TYPES.DELETE_SURVEYS_SKILLS]({ commit }, surveyId) {
    commit(MUTATION_TYPES.DELETE_SURVEYS_SKILLS, surveyId);
  },
  [ACTION_TYPES.DELETE_ALL_SURVEYS_SKILLS]({ commit }) {
    commit(MUTATION_TYPES.DELETE_ALL_SURVEYS_SKILLS);
  },
  [ACTION_TYPES.SELECT_CONFIG_SURVEY_INFO]({ commit }, selection) {
    commit(MUTATION_TYPES.SET_CONFIG_SURVEY_INFO, selection);
  },
  [ACTION_TYPES.RESET_CONFIG_SURVEY_INFO]({ commit }) {
    commit(MUTATION_TYPES.RESET_CONFIG_SURVEY_INFO);
  },
});

export {
  actions,
  ACTION_TYPES,
};
